import type { ColorScheme } from './colorSchemes'

export type CalendarEventType = 'note' | 'expense' | 'event'

// Spójne kolory dla typów wpisów
// Zastosuj te kolory w przyciskach wyboru typu i akcentach listy
// Kolory typów zależne od schematu kolorystycznego
const schemeTypeColors: Record<ColorScheme, Record<Exclude<CalendarEventType, 'event'>, string>> = {
  // Klasyczny: notatki żółte, koszty mocniej zielone
  default: {
    note: '#f59e0b',    // amber-500
    expense: '#16a34a', // green-600 (bardziej zielony)
  },
  // Ocean: bez zmian (jak wcześniej)
  ocean: {
    note: '#f59e0b',    // amber-500
    expense: '#10b981', // emerald-500
  },
  // Las: notatki czerwone, koszty fioletowe
  forest: {
    note: '#dc2626',    // red-600
    expense: '#7c3aed', // purple-600
  },
  // Zachód słońca: notatki fioletowe, koszty zielone (jak było)
  sunset: {
    note: '#7c3aed',    // purple-600
    expense: '#10b981', // emerald-500
  },
}

export function getTypeColor(type: CalendarEventType, scheme: ColorScheme = 'default'): string {
  const base = schemeTypeColors[scheme] || schemeTypeColors.default
  if (type === 'event') return base.note
  return base[type]
}


